import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Basketball = () => {
  return (
    <SportsLayoutComp name={'Basketball'}/>
  )
}

export default Basketball